export default class AllowancesCalculator {
    constructor(employee, salary, allowances) {
        this.employee = employee;
        this.salary = salary;
        this.allowances = allowances;
    }

    calculate() {
        return this.reduceHighEarnings(this.calculateByAge() + this.calculateBlind());
    }

    calculateByAge() {
        const age = this.employee.age;
        const gross = this.salary.getGross('year');
        let personalAllowance = this.allowances.personal;
        let ageAllowance = this.allowances.getAgeBandAllowance(age);
        const ageAllowanceThreshold = this.allowances.getAgeAllowanceThreshold();

        if (ageAllowance) {
            const taxable = gross - ageAllowanceThreshold;
            ageAllowance = (gross > ageAllowanceThreshold) ? ageAllowance - (taxable / 2) : ageAllowance;
        }

        personalAllowance = (ageAllowance > personalAllowance) ? ageAllowance : personalAllowance;

        return personalAllowance;
    }

    calculateBlind() {

        if (!this.employee.isBlind) {
            return 0;
        }

        return this.allowances.blind;
    }

    reduceHighEarnings(personalAllowance) {
        const isHighEarner = this.salary.getGross('year') > this.allowances.highEarnerThreshold;

        if (!isHighEarner) {
            return personalAllowance;
        }

        const gross = this.salary.getGross('year');
        let reducedAllowance = personalAllowance - ((gross - this.allowances.highEarnerThreshold) / 2);
        reducedAllowance = reducedAllowance >= 0 ? reducedAllowance : 0;

        return reducedAllowance;
    }

    /**
     * Calculate the married couples allowance to be offset against tax
     * @see http://www.which.co.uk/money/tax/guides/tax-in-retirement/married-couples-allowance/
     */
    calculateMarriedCouplesAllowance() {
        let mca = 0;
        let age = this.employee.age;
        let ageAllowance = this.allowances.getAgeBandAllowance(age);
        let isMarried = this.employee.isMarried;
        let minAge = this.allowances.getMarriageAllowanceMinAge();

        if (age >= minAge && isMarried) {
            const gross = this.salary.getGross('year');
            const ageAllowanceThreshold = this.allowances.getAgeAllowanceThreshold();

            let mcaMin = this.allowances.getMarriageAllowanceMin();
            const mcaMax = this.allowances.getMarriageAllowanceMax();
            const mcaRate = this.allowances.getMarriageAllowanceRate();

            if (gross <= ageAllowanceThreshold) {
                mca = mcaRate * mcaMax;
            } else {
                // MCA is reduced by £1 for every £2 of additional income above age allowance limit
                const taxable = gross - ageAllowanceThreshold;
                const diff = taxable / 2;
                const leftOver = diff - (ageAllowance - this.calculate());
                const taxableUnderMaxMCA = mcaMax - leftOver;

                mcaMin = mcaRate * mcaMin;
                const reducedMCA = mcaRate * taxableUnderMaxMCA;

                mca = (reducedMCA > mcaMin) ? reducedMCA : mcaMin;
            }
        }

        return mca;
    }
}